import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext, useSiteSelection } from "@context";
import { useOrganData, useManagerData } from "@hooks";
import { DashBanner, OrganGrid } from "@components";
import { ROLES } from "@constants/roles";
import DashBreadcrumb from "./DashBreadcrumb";
import "./dash.css";

const Organ = () => {
    const { auth } = useContext(AuthContext);
    const { compCode, siteCode } = useSiteSelection();
    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';

    // 훅은 조건부 return 전에 모두 호출
    const { data: organData } = useOrganData(
        compCode && siteCode
            ? { compCode: compCode, siteCode: parseInt(siteCode) }
            : null
    );
    const { data: managerData } = useManagerData(compCode ? { compCode: compCode } : {});

    if (!compCode) {
        return <Navigate to={isAdminOrR1 ? "/dash/company" : "/dash/site"} replace />;
    }
    if (!siteCode) {
        return <Navigate to="/dash/site" replace />;
    }

    const currentRoleEmpInfo  = organData?.companyInfo    || [];
    const currentData         = organData?.gridData        || [];
    const currentRoleList     = organData?.commonRoleInfo  || [];
    const currentSiteInfo     = organData?.siteInfo        || [];
    const currentSizeCategory = organData?.sizeCategory    || null;

    return (
        <>
            <DashBreadcrumb />

            <div className="contents-wrap">
                <DashBanner
                    title="이해관계자 서명"
                    description="안전 교육 및 예방 조치에 대한 이해관계자들의 서명 진행 상태를 추적하여, 법적 의무 이행 여부를 투명하게 증빙하고 관리합니다."
                />
                <OrganGrid
                    roleList={currentRoleList}
                    roleEmpInfo={currentRoleEmpInfo}
                    data={currentData}
                    siteCodes={currentSiteInfo}
                    selectedSite={siteCode}
                    onSiteChange={() => {}}
                    sizeCategory={currentSizeCategory}
                />
            </div>
            {managerData?.managerName && (
                <div className="dash-manager-info">
                    <span>담당자&nbsp;&nbsp;<strong>{managerData.managerName}</strong></span>
                    <span>연락처&nbsp;&nbsp;<strong>{managerData.managerPhone}</strong></span>
                </div>
            )}
        </>
    );
};

export { Organ };
